import useSWR from 'swr';
import { swrFetcher } from '../services/apiClient';

export function useHealth(refreshInterval = 30000) {
  // If refreshInterval is null/falsy, don't make any requests
  const shouldFetch = refreshInterval !== null && refreshInterval !== undefined;
  
  const { data, error, isLoading } = useSWR(
    shouldFetch ? '/health' : null, // Pass null to skip fetching
    swrFetcher,
    {
      refreshInterval: shouldFetch ? refreshInterval : 0,
      revalidateOnFocus: shouldFetch,
      dedupingInterval: 10000,
      errorRetryCount: 5,
      errorRetryInterval: 3000,
      shouldRetryOnError: true,
      timeout: 45000,
    }
  );

  // If not fetching, return default state
  if (!shouldFetch) {
    return {
      health: null,
      isConnected: false,
      isConnecting: false,
      isLoading: false,
      isError: false,
    };
  }

  const isConnected = !error && (data?.status === 'ok' || data?.status === 'degraded');
  const isConnecting = isLoading || (error && !data);

  return {
    health: data,
    isConnected,
    isConnecting,
    isLoading,
    isError: error && !isConnecting,
  };
}

export default useHealth;
